module.exports = "<tog-image-library-cropper-modal #imageEditor [editMode]=\"editMode\" [autoHide]=\"false\"\n  (imageChanged)=\"onImageChanged()\"></tog-image-library-cropper-modal>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/content-editor/content-editor-image-modal/content-editor-image-modal.component.html
// module id = ../../../../../src/app/shared/components/content-editor/content-editor-image-modal/content-editor-image-modal.component.html
// module chunks = 12